module.exports = __webpack_public_path__ + "img/General_Event_Icon-White.c4b4e611.png";